import React from "react";
import { Button, ButtonProps } from "antd";
import { BUTTON_VARIANTS } from "../../constants/styles";

import "./styles.scss";

type CustomButtonType = ButtonProps & {
  children: React.ReactNode;
  btnVariant: BUTTON_VARIANTS;
};

const CustomButton = ({ children, btnVariant, ...props }: CustomButtonType) => {
  return (
    <Button
      {...props}
      className={`CustomButton CustomButton-${btnVariant} ${props.className}`}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
